import { render, staticRenderFns } from "./technologyWidge.vue?vue&type=template&id=421896ae&scoped=true"
import script from "./technologyWidge.vue?vue&type=script&lang=js"
export * from "./technologyWidge.vue?vue&type=script&lang=js"
import style0 from "./technologyWidge.vue?vue&type=style&index=0&id=421896ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421896ae",
  null
  
)

export default component.exports